export const newsSource = {
  en: "View Source",
  id: "Sumber",
  ch: "来源",
};
